// extracted by mini-css-extract-plugin
export default {"container":"PackageCard_container__txckQ","tokens-list":"PackageCard_tokens-list__G7WkG","padding":"PackageCard_padding__MKkcM","row":"PackageCard_row__BATOz"};